import 'reflect-metadata';
import './core/bytes/polyfill';
import { render } from 'preact';
import { App } from './app';
import './styles.css';
import { setupDesktop } from './ui/state/desktop';

setupDesktop();
render(<App />, document.getElementById('app')!);
